import { render, staticRenderFns } from "./GamesScoreTable.vue?vue&type=template&id=2aef6658&lang=pug"
import script from "./GamesScoreTable.vue?vue&type=script&lang=js"
export * from "./GamesScoreTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports